import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../hooks/useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../hooks/api/v2/apiV2Request";

export const useSellarDownloadPalletPickingList = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: ({
      palletId,
      view,
    }: {
      palletId: number;
      view: "sku" | "order";
    }) =>
      apiV2Request({
        user,
        business,
        method: "GET",
        path: `distribution-pallet-shipment/${palletId}/download-picking-list?view=${view}`,
      }).then((response) => apiV2AssertResponse<string>(response).data),
  });
};
